import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const SingleRunnerCard = ({ token }) => {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    axios.get(`${API_URL}/api/admin/single-runner-health`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setData(r.data)).catch((e) => setErr(e.response?.data?.detail || 'could not load'));
  }, [token]);
  if (err) return <p className="text-xs text-red-600" data-testid="single-runner-card-error">Single-runner health: {err}</p>;
  if (!data) return <p className="text-xs text-muted-foreground" data-testid="single-runner-card-loading">Loading single-runner health…</p>;
  const geo = data.country_db || {};
  const tone = data.ok ? 'border-green-200 bg-green-50' : 'border-amber-300 bg-amber-50';
  return (
    <div className={`rounded-2xl border p-5 mb-6 ${tone}`} data-testid="single-runner-card">
      <p className="font-semibold text-sm" data-testid="single-runner-status">
        Single-runner health — {data.ok ? 'ok' : 'attention'} · {data.registered_jobs} jobs · locks {data.job_locks} (TTL {data.lock_ttl_minutes} min) ·
        duplicate slots (7 d): <span className="font-mono" data-testid="single-runner-dupes">{data.duplicate_slots_7d.length}</span>
      </p>
      {data.duplicate_slots_7d.length > 0 && (
        <p className="text-xs font-mono text-red-700 mt-1">{data.duplicate_slots_7d.map((d) => `${d.job_id}@${d.slot} ×${d.rows}`).join(' · ')}</p>
      )}
      <p className={`text-xs mt-2 ${geo.stale ? 'text-amber-800 font-semibold' : 'text-muted-foreground'}`} data-testid="country-db-age">
        Country database: {geo.present ? `built ${geo.build_date}, ${geo.age_days} days old` : 'not present'}{geo.warning ? ` — ${geo.warning}` : ''}
      </p>
      <details className="mt-2">
        <summary className="text-xs cursor-pointer">Last run per job</summary>
        <ul className="text-[11px] font-mono mt-1 space-y-0.5">
          {data.jobs.map((j) => (
            <li key={j.job_id} data-testid={`job-row-${j.job_id}`}>
              {j.job_id}: {j.last_run ? `${j.last_run.status} @ ${(j.last_run.slot || j.last_run.started_at || '').slice(0, 16)}Z` : 'no run yet'} · next {j.next_run ? j.next_run.slice(11, 16) + 'Z' : '—'}
            </li>
          ))}
        </ul>
      </details>
    </div>
  );
};
